import { Box, Typography } from "@material-ui/core";
import React from "react";

const Map = () => {
  return (
    <div>
      <Typography variant="h5" className="adminHomeTitle">
        Sales Mapping by Country
      </Typography>
      <Box>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d326948.2109828979!2d54.92408675744101!3d25.125495167727223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sbd!4v1665478117118!5m2!1sen!2sbd"
          width="100%"
          height="360px"
          style={{ border: "0" }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </Box>
    </div>
  );
};

export default Map;
